/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BaseSearchFilterElementDto } from './BaseSearchFilterElementDto';

export type IncidentMutingStatusSearchFilterElementDto = (BaseSearchFilterElementDto & {
    id?: IncidentMutingStatusSearchFilterElementDto.id;
});

export namespace IncidentMutingStatusSearchFilterElementDto {

    export enum id {
        MUTED = 'MUTED',
        NOT_MUTED = 'NOT_MUTED',
    }


}
